module.exports = __webpack_public_path__ + "static/media/tailor_dai (1).55b839af.png";